import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InsuranceRejection } from '../models/insurance-rejection';
import { ResponseModel } from '../models/response-model';

@Injectable({
  providedIn: 'root'
})
export class InsuranceRejectionService {
  private url = `${environment.url}/insuranceRejection`;
  constructor(private readonly http: HttpClient) { }

  createInsuranceRejection(invoiceCode: string, createdAt: string) {
    const body = {
      invoiceCode,
      createdAt
    };
    return this.http.post<ResponseModel<InsuranceRejection>>(`${this.url}/create`, body,);
  }
}
